/**
 * AFW Sidebar Vehicle Search Widget
 * Compact Year/Make/Model search inside the collection sidebar.
 * Uses NHTSA VPIC API for model lookups.
 * Handles lazy-loaded sidebar (template[t4splitlz]) via polling.
 *
 * @version 1.0.0
 */
(function () {
  'use strict';

  var NHTSA = 'https://vpic.nhtsa.dot.gov/api/vehicles';
  var MAKES = [
    'Acura','Alfa Romeo','Audi','BMW','Buick','Cadillac','Chevrolet','Chrysler',
    'Dodge','FIAT','Ford','Genesis','GMC','Honda','Hyundai','INFINITI','Jaguar',
    'Jeep','Kia','Land Rover','Lexus','Lincoln','Maserati','Mazda','Mercedes-Benz',
    'MINI','Mitsubishi','Nissan','Porsche','Ram','Rivian','Subaru','Tesla',
    'Toyota','Volkswagen','Volvo'
  ];

  /* ===== Wait for sidebar DOM (lazy-loaded via template[t4splitlz]) ===== */
  var maxAttempts = 60; // 60 * 250ms = 15s max
  var attempts = 0;
  var pollTimer = setInterval(function () {
    attempts++;
    if (document.getElementById('afw-sv-year')) {
      clearInterval(pollTimer);
      init();
    } else if (attempts >= maxAttempts) {
      clearInterval(pollTimer);
    }
  }, 250);

  // Also try immediately in case sidebar is already in DOM
  if (document.getElementById('afw-sv-year')) {
    clearInterval(pollTimer);
    init();
  }

  function init() {
    var yearEl     = document.getElementById('afw-sv-year');
    var makeEl     = document.getElementById('afw-sv-make');
    var modelEl    = document.getElementById('afw-sv-model');
    var searchBtn  = document.getElementById('afw-sv-search');
    var activeBar  = document.getElementById('afw-sv-active');
    var activeText = document.getElementById('afw-sv-active-text');
    var changeBtn  = document.getElementById('afw-sv-change');
    var controlsEl = document.getElementById('afw-sv-controls');
    var clearEl    = document.getElementById('afw-sv-clear');

    if (!yearEl) return;

    /* ---------- sessionStorage: restore vehicle ---------- */
    var stored = null;
    try {
      var s = sessionStorage.getItem('afw_vehicle');
      if (s) stored = JSON.parse(s);
    } catch (e) {}

    if (stored && stored.year && stored.make && stored.model) {
      showActive(stored.year, stored.make, stored.model);
    }

    /* ---------- Populate Year ---------- */
    var now = new Date().getFullYear() + 1;
    var html = '<option value="">Year</option>';
    for (var y = now; y >= 1960; y--) html += '<option value="' + y + '">' + y + '</option>';
    yearEl.innerHTML = html;
    yearEl.disabled = false;

    /* ---------- Year → Make ---------- */
    yearEl.addEventListener('change', function () {
      makeEl.innerHTML = '<option value="">Make</option>';
      modelEl.innerHTML = '<option value="">Model</option>';
      modelEl.disabled = true;
      searchBtn.disabled = true;
      if (!this.value) { makeEl.disabled = true; return; }
      html = '<option value="">Make</option>';
      MAKES.forEach(function (m) { html += '<option value="' + m + '">' + m + '</option>'; });
      makeEl.innerHTML = html;
      makeEl.disabled = false;
    });

    /* ---------- Make → Model (NHTSA) ---------- */
    makeEl.addEventListener('change', function () {
      modelEl.innerHTML = '<option value="">Loading...</option>';
      modelEl.disabled = true;
      searchBtn.disabled = true;
      if (!this.value) { modelEl.innerHTML = '<option value="">Model</option>'; return; }
      var yr = yearEl.value, mk = this.value;
      fetch(NHTSA + '/GetModelsForMakeYear/make/' + encodeURIComponent(mk) + '/modelyear/' + yr + '?format=json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var models = (d.Results || []).map(function (m) { return m.Model_Name; })
            .filter(function (v, i, a) { return a.indexOf(v) === i; }).sort();
          if (!models.length) models = ['Other'];
          html = '<option value="">Model</option>';
          models.forEach(function (m) { html += '<option value="' + m + '">' + m + '</option>'; });
          modelEl.innerHTML = html;
          modelEl.disabled = false;
        })
        .catch(function () {
          modelEl.innerHTML = '<option value="">Model</option><option value="Other">Other</option>';
          modelEl.disabled = false;
        });
    });

    /* ---------- Model select → enable Search ---------- */
    modelEl.addEventListener('change', function () {
      searchBtn.disabled = !this.value;
    });

    /* ---------- SEARCH ---------- */
    searchBtn.addEventListener('click', function () {
      var yr = yearEl.value, mk = makeEl.value, md = modelEl.value;
      if (!yr || !mk || !md) return;

      // Persist
      try {
        sessionStorage.setItem('afw_vehicle', JSON.stringify({ year: yr, make: mk, model: md }));
      } catch (e) {}

      // ── TAG-BASED COLLECTION FILTERING ──
      // Products are tagged: make:Ford, model:F-150, year:2020
      // Shopify filters server-side: /collections/{handle}/tag1+tag2+tag3
      var tagParts = ['make:' + mk, 'model:' + md, 'year:' + yr];
      var tagPath = tagParts.join('+');

      // If already on a collection page, filter within that collection
      var pathParts = window.location.pathname.split('/');
      var collHandle = 'all';
      if (pathParts[1] === 'collections' && pathParts[2]) {
        collHandle = pathParts[2];
      }

      window.location.href = '/collections/' + collHandle + '/' + tagPath;
    });

    /* ---------- CLEAR ---------- */
    if (clearEl) {
      clearEl.addEventListener('click', function (e) {
        e.preventDefault();
        try { sessionStorage.removeItem('afw_vehicle'); } catch (e) {}
        if (window.location.pathname === '/search') {
          window.location.href = '/collections/all';
        } else {
          window.location.href = window.location.pathname.split('?')[0];
        }
      });
    }

    /* ---------- CHANGE — re-show dropdowns ---------- */
    if (changeBtn) {
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        activeBar.style.display = 'none';
        activeBar.classList.remove('is-visible');
        controlsEl.style.display = '';
        // Pre-fill dropdowns with stored vehicle
        if (stored) {
          yearEl.value = stored.year;
          yearEl.dispatchEvent(new Event('change'));
          setTimeout(function () {
            makeEl.value = stored.make;
            makeEl.dispatchEvent(new Event('change'));
            setTimeout(function () {
              modelEl.value = stored.model;
              modelEl.dispatchEvent(new Event('change'));
            }, 1500);
          }, 100);
        }
      });
    }

    /* ---------- Show active vehicle ---------- */
    function showActive(yr, mk, md) {
      if (activeText) activeText.textContent = yr + ' ' + mk + ' ' + md;
      activeBar.style.display = '';
      activeBar.classList.add('is-visible');
      controlsEl.style.display = 'none';
      if (clearEl) clearEl.style.display = 'block';
    }
  }
})();
